module.exports = __webpack_public_path__ + "static/img/h5_icon.bc69f64e.png";